export default {
    blueprintEdit: 'Edit',
    blueprint: 'BluePrint',
    export: 'Export',
    template_general: 'General',
    templates: 'Templates',
    regex: 'Regex',
    share: 'Share',
    gallery: 'Gallery',
    logs: 'Logs',
    projects_stats: 'Logs',
    cclights: 'CC LIGHT',
    appPanels: 'APP PANEL',
    sfxdata_meta_data: 'Meta Data',
    font: 'Font',
    profiles: 'Profile',
    exportprofiles: 'Profile',
    exportprofiles_general: 'General',
    projects_preview: '3D Web View',
    organizations_overview: 'Organizations',
    organizations_add: 'Add Organization',
    organization: 'Organization',
    organization_dashboard: 'Dashboard',
    help: 'Help',
    texture: 'Textures',
    texture_general: 'General',
    texturebackbutton: 'Back',
    blueprintsbackbutton: 'Back',
    add_texture: 'Add texture',
    projects_details: 'Share',
    projects_gallery: 'Gallery',
    projects_home: 'Home',
    versions: 'Versions',
    instance: 'Instance',
    instance_general: 'General',
    costOverview: 'Cost Overview',
    saasServices: 'SAAS SERVICES',
    saasAgb: 'SAAS AGB',
    csv_import: 'CSV Import',
    createVirtualMachine: 'Create VM',
    vmOverview: 'VM Overview',
    vmUsageAll: 'VM ALL',
    myVmUsage: 'VM Usage',
    vmUsage: 'VM Usage',
    adminproject: 'General Projects',
    taskmanager: 'Taskmanager',
    scene_general: 'General',
    scenebackbutton: 'Back',
    vmbackbutton: 'Back',
    scnee: 'Scene',
    scenes: 'Scenes',
    service_edit: 'General',
    rolebackbutton: 'Back',
    permissionsbackbutton: 'Back',
    permission_edit: 'General',
    permissions: 'Permissions',
    roles: 'Roles',
    material_general: 'General',
    materials: 'Materials',
    team_general: 'General',
    teams: 'Teams',
    organizing: 'Structure',
    qrcodes: 'QR-Codes',
    materialmappers: 'Mappers',
    services: 'Services',
    materialbackbutton: 'Back',
    materialmapbackbutton: 'Back',
    servicebackbutton: 'Back',
    teambackbutton: 'Back',
    sfxdata_export_profiles: 'Export profiles',
    files: 'Files',
    library_files: 'Files',
    library_3d_files: 'Files',
    access_denied: 'Access Denied',
    users: 'Users',
    tags: 'Tags',
    admin: 'Admin',
    projects: 'Projects',
    project: 'Projects',
    form_general: 'General',
    forms: 'Forms',
    formbackbutton: 'Back',
    media: 'Media',
    addMedia: 'Create media object',
    uploadMediaFile: 'Upload media file',
    apps: 'apps',
    app: 'apps',
    logout: 'logout',
    SFXData: '3D-Data',
    account: 'Account',
    organizations: 'Organizations',
    project_scene: "Scene",
    project_general: "General",
    project_3ddata: "3D-Data",
    project_media: 'Media',
    report_general: "General",
    sfxdata: "3D-Data",
    sfxdata_general: "General",
    sfxdata_general_assembly: "General",
    project_datasets: "Data Sources",
    project_datasources: "Data Sources",
    reports: "Reports",
    report: "Reports",
    sfxdata_data_sets: "Data Sources",
    sfxdata_media: "Media",
    sfxdata_assembly_update: "Update",
    texts: "Texts",
    text_general: "General",
    app_general: "General",
    media_general: "General",
    font_general: "General",
    user_general: "General",
    app_project: "Project",
    qrcode_general: "General",
    materialmapper_general: "General",
    data: "Data",
    data_tables: "Data Tables",
    data_sources: "Data Sources",
    data_sources_general: "General",
    datasets: "Datasets",
    dataset_general: "General",
    datasources: "Data Sources",
    resources: "Resources",
    library: "Library",
    modelbackbutton: "Back",
    assemblybackbutton: "Back",
    reportbackbutton: "Back",
    projectsbackbutton: "Back",
    projectbackbutton: "Back",
    userbackbutton: "Back",
    appbackbutton: "Back",
    webappbackbutton: "Back",
    sfxbackbutton: "Back",
    mediabackbutton: "Back",
    datasetbackbutton: "Back",
    datasourcebackbutton: "Back",
    metasetbackbutton: "Back",
    textbackbutton: "Back",
    qrcodebackbutton: "Back",
    materialmapperbackbutton: "Back",
    organizationbackbutton: "Back",
    sfxdata_linked_data: "Linked Data",
    project_linked_data: "Linked Data",
    sfxdata_connection_list: "Linked Data List",
    addnew3ddata: "Create new 3D Object",
    Upload: "Upload",
    Config: "Config",
    metasets: "Metasets",
    metaSets: "Metasets",
    webapp_linked_data: "Linked Data"
}